import { ReactComponent as AddIcon } from "assets/icons/add-plus.svg";
import Button from "components/button/Button";
import MyButton from "components/MyButton";
import React, { useState } from "react";
import AddMourners from "../NewYahrzeit/AddMourners";
import MournersList from "../NewYahrzeit/MournersList";

const DrawerMournerList = ({
  handleDelete,
  mourners,
  onSubmit,
  isEdit,
  disableEditing,
  openAddMournerModal,
  ...props
}) => {
  const [disable, setDisable] = useState(true);

  return (
    <div className="">
      <MournersList
        drawerDisplay={true}
        {...props}
        handleDelete={handleDelete}
        handleClick={() => {}}
        mourners={mourners}
        isEdit={isEdit}
        setDisable={setDisable}
        onEditClick={(mourner) => {
          openAddMournerModal(mourners, "edit", mourner)
        }}
      />
      <div
        className="add-new-payment-info mt-4 justify-content-center"
        onClick={() => {
          openAddMournerModal(mourners);
        }}
      >
        <span className="add-icon">
          <AddIcon width={16} height={16} />
        </span>
        <span className="add">Add New Mourner</span>
      </div>
      <hr />
      <div className="mt-4 btn-flex d-flex justify-content-center">
        <Button
          variant={"primary"}
          size="md"
          onClick={onSubmit}
          disabled={disable || disableEditing}
          style={{ minWidth: "120px" }}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default DrawerMournerList;
